import { Component, computed, signal } from '@angular/core'; // Uso de Signals
import { HttpErrorResponse } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { AnalyticsService } from '../../services/analytics.service';
import { ErrorModel } from '../../models/error.model';
import { ConfigService } from '../../core/config/config.service';
import { formatoLoginValido, separarUsuarioETenant } from '../../core/utils/login-tenant.util';

const MSG_FORMATO = 'Informe usuário e empresa no formato usuario@empresa.';
const MSG_401 = 'Usuário, empresa ou senha inválidos.';
const MSG_429 = 'Muitas tentativas. Aguarde alguns minutos e tente novamente.';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, CommonModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  username = signal('');
  password = signal('');
  showPassword = signal(false);

  readonly mensagemFormato = MSG_FORMATO;
  readonly exigeTenant = computed(() => this.configService.settings()?.loginExigeTenant === true);
  readonly formatoInvalido = computed(() => this.exigeTenant() && !formatoLoginValido(this.username()));
  readonly mostrarErroFormato = computed(() => this.formatoInvalido() && this.username().trim().length > 0);

  constructor(
    private router: Router, 
    private authService: AuthService, 
    private analyticsService: AnalyticsService,
    private configService: ConfigService
  ) {}

  login() {
    if (this.formatoInvalido()) {
      return;
    }
    const { usuario, tenant } = separarUsuarioETenant(this.username());
    const payload: { nomeUsuario: string; senha: string; tenant?: string } = {
      nomeUsuario: usuario,
      senha: this.password()
    };
    if (tenant) {
      payload.tenant = tenant;
    }

    this.authService.login(payload)
      .subscribe({
        next: (data) => {
          this.analyticsService.saveUsage({ 
            username: usuario, 
            acao: 'login' 
          }).subscribe();
          
          this.router.navigate(['/home']);
        },
        error: (err: HttpErrorResponse) => {
          const erro = err.error as ErrorModel | null;
          if (err.status === 403 && erro?.code === '403-10') {
            alert(erro.message || 'Acesso temporariamente indisponível para esta empresa. Entre em contato com o suporte Kali.');
            return;
          }
          if (err.status === 401) {
            alert(MSG_401);
            return;
          }
          if (err.status === 429) {
            alert(MSG_429);
            return;
          }
          alert('Credenciais inválidas para o sistema Kali.');
        }
      });
  }
}